<template>
  <div class="card" v-if="nuevoProducto">
    <!-- <CrudProveedor></CrudProveedor> -->
  </div>
  <ProductoCreate
    :mostrar="mostrarProductoModal"
    :producto="producto"
    @closeModal="cerrarModal"
    @actualizarListadoProductos="obtenerListadoProductos"
  ></ProductoCreate>
  <ul class="estilos-breadcrumb">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Par&aacute;metros</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Productos</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <router-link to="/productos" class="text-900 line-height-3"
        >Listado de Productos</router-link
      >
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Productos
          <Badge size="xlarge" severity="success"> {{ totalRecords }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          label="Nuevo"
          v-if="'Producto Crear' in auth.user.permissions"
          class="p-button-outlined p-button-lg"
          icon="pi pi-plus"
          v-tooltip.top="'Registrar Nuevo Producto'"
          @click="openModal"
          :disabled="!cargando ? false : true"
        ></Button>
      </div>
    </div>

    <div class="col-12 estilos-form mt-2">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-2">
          <span><strong>C&Oacute;D. INT.:</strong></span>
          <InputNumber
            :class="'text-right'"
            v-model="codigo_producto"
            mode="decimal"
            :useGrouping="false"
            @keyup.enter="obtenerListadoProductos()"
          />
        </div>
        <div class="field col-12 md:col-4">
          <span><strong>NOMBRE/DESCRIPCI&Oacute;N:</strong></span>
          <InputText
            v-model="descripcion"
            @keyup.enter="obtenerListadoProductos()"
          />
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>PRINCIPIO ACTIVO:</strong></span>
          <InputText
            v-model="principio_activo"
            @keyup.enter="obtenerListadoProductos()"
          />
        </div>
        <div class="field col-12 md:col-1">
          <span><strong>REGISTROS:</strong></span>
          <Dropdown
            v-model="cantidadSeleccionada"
            :options="cantidades"
            optionLabel="label"
            optionValue="value"
            @change="mostrarMasProducto"
          />
        </div>
        <div class="field col-12 md:col-2">
          <span>&nbsp;</span>
          <Button
            label="BUSCAR"
            icon="pi pi-search"
            class="p-button-info"
            @click="obtenerListadoProductos()"
          />
        </div>
      </div>
    </div>
    <div class="mt-2">
      <DataTable
        ref="dtproductos"
        dataKey="id"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[20, 50, 100, 500, 1000]"
        :totalRecords="totalRecords"
        :currentPageReportTemplate="
          'Mostrando {first} de ' + totalRecords + ' Registros'
        "
        responsiveLayout="scroll"
        :rows="20"
        stripedRows
        showGridlines
        :value="productos"
        :loading="cargando"
        :paginator="true"
        :rowHover="true"
        selectionMode="single click"
        @row-dblclick="editarProducto($event.data)"
      >
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >
        <Column
          field="id"
          header="CÓD."
          style="width: 30px"
          :class="'text-right'"
        />
        <Column
          field="descripcion"
          header="DESCRIPCIÓN/DETALLE"
          style="width: 250px; font-weight: bold"
        />
        <Column
          field="imagen"
          header="IMAGEN"
          v-if="'Producto VerImagen' in auth.user.permissions"
        >
          <template #body="{ data }">
            <template v-if="data.imagen != null">
              <Image
                :src="'data:image/png;base64, ' + data.imagen"
                width="30"
                preview
              ></Image>
            </template>
            <template v-else><p>---</p></template>
          </template>
        </Column>
        <Column field="fabricas.nombre" header="LABORATORIO" />

        <Column field="unidad_medida_nombre" header="U.MEDIDA">
          {{ data.unidad_medida_nombre }}
        </Column>
        <Column class="text-center" field="stock_actual" header="STOCK">
          <template #body="{ data }">
            <div :class="claseEstado2(data)">
              {{ sinDecimal(data.stock_actual) }}
            </div>
          </template>
        </Column>
        <Column field="precio_compra" header="P.COMPRA" class="text-right">
          {{ convertirNumeroGermanicFormat(data.precio_compra) }}
        </Column>
        <Column field="precio_sugerido" header="PV1" class="text-right">
          <template #body="{ data }">
            <span v-if="data.precio_venta == 0">
              {{ convertirNumeroGermanicFormat(data.precio_sugerido) }}
            </span>
            <span v-else>
              {{ convertirNumeroGermanicFormat(data.precio_venta) }}
            </span>
          </template>
        </Column>
        <Column field="pv2" header="PV2" class="text-right">
          {{ convertirNumeroGermanicFormat(data.pv2 || 0) }}
        </Column>
        <Column field="pv3" header="PV3" class="text-right">
          {{ convertirNumeroGermanicFormat(data.pv3 || 0) }}
        </Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <Badge v-if="data.estado == 1" size="small" severity="success"
              >ACTIVO</Badge
            >
            <Badge v-else size="small" severity="danger">INACTIVO</Badge>
          </template>
        </Column>
        <Column style="width: 3rem">
          <template #header>
            <i class="pi pi-check-circle ml-1"></i>
          </template>
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised p-button-rounded p-button-info"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>
    <Dialog
      v-model:visible="deleteProdModal"
      :style="{ width: '450px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="producto"
          >Estas Seguro que quieres eliminar producto:
          <b>{{ producto.descripcion }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="No, Cancelar"
          icon="pi pi-times"
          class="p-button-success p-button-lg"
          @click="deleteProdModal = false"
        />
        <Button
          label="Si Eliminar"
          icon="pi pi-check"
          class="p-button-danger p-button-lg"
          @click="deleteProducto"
        />
      </template>
    </Dialog>
    <ProductoImagenes
      :show="verImagenes"
      :producto_id="ProductoImagenes"
      :producto_nombre="producto.descripcion"
      @closeModal="ocultarDialog"
      @actualizarListado="obtenerListadoProductos"
    ></ProductoImagenes>
    <KardexProducto
      :show="verKardex"
      :producto_id_nombre="KardexProducto"
      @closeModal="ocultarDialogKardex"
    ></KardexProducto>
  </div>
</template>

<script>
import ProductService from "@/service/ProductService";
import ProductoCreate from "@/module/productos/ProductoCreate.vue";
import { useAuth } from "@/stores";
import ProductoImagenes from "@/module/productos/ProductoImagenes.vue";
import KardexProducto from "@/module/kardex/KardexProducto.vue";

export default {
  components: { ProductoCreate, ProductoImagenes, KardexProducto },
  data() {
    return {
      nuevoProducto: false,
      totalRegistros: 0,
      totalRecords: 0,
      productos: [],
      cargando: true,
      mostrarProductoModal: false,
      producto: {},
      deleteProdModal: false,
      claseEstado: ["status-outofstock", "status-instock"],
      claseEstado2: (data) => {
        if (data.stock_actual <= 0) {
          return "outofstock";
        } else if (data.stock_actual <= 10) {
          return "lowstock";
        } else {
          return "instock";
        }
      },
      verImagenes: false,
      ProductoImagenes: null,
      verKardex: false,
      KardexProducto: {},
      codigo_producto: null,
      descripcion: "",
      principio_activo: "",
      cantidadSeleccionada: 50,
      cantidades: [
        { label: "50", value: 50 },
        { label: "100", value: 100 },
        { label: "500", value: 500 },
        { label: "1000", value: 1000 },
      ],
    };
  },
  productoService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.productoService = new ProductService();
  },
  mounted() {
    this.obtenerListadoProductos();
  },
  methods: {
    mostrarMasProducto() {
      this.obtenerListadoProductos();
    },
    sinDecimal(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
      }).format(numero);
    },

    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },

    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "Producto Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editarProducto(datos);
          },
        },
        {
          label: "Ver Detalle",
          disabled:
            "Producto Ver Detalle" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-eye",
          command: () => {
            this.verDetalle(datos);
          },
        },
        {
          label: "Ver Imagenes",
          icon: "pi pi-image",
          disabled: "Producto VerImagen" in permisosUsuarioAuth ? false : true,
          command: () => {
            this.mostrar_imagenes(datos.id);
          },
        },
        {
          label: "Eliminar",
          disabled: "Producto Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.confirmDeleteProducto(datos);
          },
        },
        {
          label: "Ver Kardex",
          icon: "pi pi-file",
          disabled:
            "Inventario KardexProductos" in permisosUsuarioAuth ? false : true,
          command: () => {
            this.verKardexProducto(datos.id, datos.descripcion);
          },
        },
      ];
    },
    verKardexProducto(id, descripcion) {
      this.KardexProducto = { id, descripcion };
      this.verKardex = true;
    },
    ocultarDialogKardex() {
      this.verKardex = false;
    },
    ocultarDialog() {
      this.verImagenes = false;
    },
    mostrar_imagenes(producto_id) {
      this.ProductoImagenes = producto_id;
      this.verImagenes = true;
    },
    openModal() {
      this.producto = {
        estado: { label: "Activo", value: 1 },
        stock_minimo: null,
        stock_maximo: null,
        precio_sugerido: null,
        tipo_catalogo: 1,
      };
      this.mostrarProductoModal = true;
    },
    cerrarModal() {
      this.mostrarProductoModal = false;
      this.producto = {};
    },
    obtenerListadoProductos() {
      let datos = {
        cantidadSeleccionada: this.cantidadSeleccionada,
        codigo_producto: this.codigo_producto,
        descripcion: this.descripcion,
        principio_activo: this.principio_activo,
      };
      this.cargando = true;
      this.productoService.getAllProductosListado(datos).then((data) => {
        this.totalRecords = data.totalRecords ?? 0;
        this.productos = data.productos ?? [];
        this.cargando = false;
      });
    },
    textoEstado(estado) {
      return estado == 1 ? "Activo" : "Inactivo";
    },
    editarProducto(info_producto) {
      this.producto = { ...info_producto };
      this.producto.estado = {
        label: this.textoEstado(info_producto.estado),
        value: info_producto.estado,
      };
      this.producto.stock_minimo =
        this.producto.stock_minimo != null
          ? parseInt(this.producto.stock_minimo)
          : null;
      this.producto.stock_maximo =
        this.producto.stock_maximo != null
          ? parseInt(this.producto.stock_maximo)
          : null;
      this.producto.precio_sugerido =
        this.producto.precio_sugerido > 0
          ? parseFloat(this.producto.precio_sugerido)
          : null;
      this.producto.precio_compra =
        this.producto.precio_compra > 0
          ? parseFloat(this.producto.precio_compra)
          : null;
      this.producto.stock_actual =
        this.producto.stock_actual > 0
          ? parseInt(this.producto.stock_actual)
          : null;
      this.producto.tipo_catalogo = parseInt(this.producto.tipo_catalogo || 1);
      this.producto.pv2 =
        this.producto.pv2 > 0 ? parseInt(this.producto.pv2) : null;
      this.producto.pv3 =
        this.producto.pv3 > 0 ? parseInt(this.producto.pv3) : null;

      this.mostrarProductoModal = true;
    },
    verDetalle(producto) {
      this.$router.push(`/producto/${producto.id}/detalle`);
    },
    confirmDeleteProducto(producto) {
      this.producto = { ...producto };
      this.deleteProdModal = true;
    },
    deleteProducto() {
      this.productoService.deleteProducto(this.producto).then((response) => {
        if (response.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Exito",
            detail: response.mensaje,
            life: 3000,
          });
          this.productos = this.productos.filter(
            (val) => val.id !== this.producto.id
          );
          this.deleteProdModal = false;
          this.producto = {};
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.mensaje,
            life: 3000,
          });
          this.deleteProdModal = false;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}
.outofstock {
  font-weight: 700;
  color: #000000;
  background-color: #ff5252;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}
.estilos-form {
  background-color: #ececec;
  border: 1px solid #000;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 10px;
}
.estilos-breadcrumb {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #06a0cb;
  border-radius: 5px;
  padding: 2px;
}
</style>
